import { atom, WritableAtom } from 'jotai';
import { lzFLocalStorageGet, lzFLocalStoragePut } from '@lz-services/LocalStorage';

export const lzSAtomWithLocalStorage: <T>(localStorageKey: string, initialValue: T) => WritableAtom<T, [update: unknown], void> =
    (localStorageKey, initialValue) => {
        const baseAtom = atom(lzFLocalStorageGet(localStorageKey, initialValue));

        return atom(
            (get) => get(baseAtom),
            (get, set, update) => {
                const newValue = typeof update === 'function' ? update(get(baseAtom)) : update;
                set(baseAtom, newValue);
                lzFLocalStoragePut(localStorageKey, newValue);
            },
        )
    };
